import { createApiSlice } from "@common";
import {
    CURD_OPPORTUNITY_STAGE
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addOpportunityStage",
        method: "post",
        url: CURD_OPPORTUNITY_STAGE,
        stateKey: "message",
    },
    {
        name: "getOpportunityStage",
        method: "get",
        url: CURD_OPPORTUNITY_STAGE,
        stateKey: "data",
    },
    {
        name: "updateOpportunityStage",
        method: "put",
        url: CURD_OPPORTUNITY_STAGE,
        stateKey: "message",
    },
    {
        name: "deleteOpportunityStage",
        method: "delete",
        url: CURD_OPPORTUNITY_STAGE,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "opportunityStage",
    apiConfig,
    customReducers,
);
const opportunityStageSlice = slice;
// Export the slice's reducer
export default opportunityStageSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addOpportunityStage,
    getOpportunityStage,
    updateOpportunityStage,
    deleteOpportunityStage
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
